import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const WatermarkContext = createContext({ hidden: false, toggle: () => {} });

export function WatermarkProvider({ children }) {
  const { currentUser } = useAuth();
  const [preference, setPreference] = useState(null);
  const owner = currentUser?.id ?? currentUser?.sub ?? currentUser?.email;
  useEffect(() => { setPreference(null); }, [owner, currentUser?.is_admin]);
  const hidden = Boolean(currentUser?.is_admin && preference?.owner === owner && preference.hidden);
  const toggle = () => {
    if (!currentUser?.is_admin || owner == null) return;
    setPreference({ owner, hidden: !hidden });
  };
  return <WatermarkContext.Provider value={{ hidden, toggle }}>{children}</WatermarkContext.Provider>;
}

export const useWatermark = () => useContext(WatermarkContext);

export function WatermarkVisibility({ children }) {
  const { hidden } = useWatermark();
  const { currentUser } = useAuth();
  const { pathname, search } = useLocation();
  const isBladeSelector = pathname === "/login" &&
    new URLSearchParams(search).get("menu") === "1" && Boolean(currentUser);
  const isVaultLogin = pathname === "/login" && !isBladeSelector;
  return hidden || isVaultLogin ? null : children;
}